import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import {
    SignupDocumentStatus,
    SignupDocumentVerificationResult,
} from "../../../models/user/dto/user.dto";

// Admin-only response. Verification fields live here (not on /users/:id/details)
// to keep the extracted PII (uniqueId, institution) behind AdminAuthGuard.
export type SignupDocumentResponse = {
    url: string;
    contentType: string;
    verificationResult: SignupDocumentVerificationResult | null;
    verifiedAt: string | null;
    status: SignupDocumentStatus | null;
};

export const GET_SIGNUP_DOCUMENT_QUERY_KEY = (userId: string) => [
    'signup-document-url',
    userId,
];

export const useGetSignupDocumentUrl = (userId: string, enabled: boolean) => {
    const client = useApiClient();

    return useQuery({
        queryKey: GET_SIGNUP_DOCUMENT_QUERY_KEY(userId),
        queryFn: () =>
            client.fetchApi<SignupDocumentResponse, {}>({
                endpoint: `users/${userId}/signup-document`,
                method: 'GET',
            }),
        enabled: Boolean(userId) && enabled,
        // SAS tokens expire after 2h (see get-signup-document-url.ts). Refetch
        // when the tab regains focus to refresh the URL transparently; without
        // this an admin who leaves the UserPage open past the TTL sees a
        // broken iframe/img with no recovery path. 45 min staleTime keeps the
        // cache fresh under the 2h SAS window.
        staleTime: 45 * 60 * 1000,
        refetchOnWindowFocus: true,
    });
};
